import DashboardNotification from "VuePartials/DashboardNotificationsShow";

export default {
  components: { DashboardNotification },
  filters: {
    formatDateTime: function (value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    },
  },
  data: () => ({
    user: window.user,
    feeds: window.feeds,
    analytics_enabled: true,
    dashboard_notifications: window.dashboard_notifications,
    loading: true,
  }),
  created() {
    this.analytics_enabled = this.permissionsCanAccessFeature('analytics');
  },
  mounted() {
    // Event triggered when dismissing a dashboard notification
    EventBus.$on("notification_dismissed", (payload) => {
      // Find the index for the dismissed notification and remove it from notifications
      // This is to force active notifications to recompute and remove the portlet if empty
      const notification_index = _.findIndex(this.dashboard_notifications, notification => notification.id === payload.notification_id);
      if (notification_index !== -1) {
        this.dashboard_notifications.splice(notification_index, 1);
      }
    });

    this.loading = false;
  },
  computed: {
    activeDashboardNotifications() {
      return _.filter(this.dashboard_notifications, notification => !window.$cookies.get(`dashboard_notification_dismissed_${notification.id}`));
    },
  },
};
